import { graphql } from 'react-relay'

export const profileQuery = graphql`
  query ProfileQuery($uuid: String!) {
    profile(uuid: $uuid) {
      name
      insertedAt
      hasProfileImage
      votes
      eliteSeatProgress {
        currentLevelName
        currentTier
        wagerAmountUsd
      }
    }
  }
`
